<script>
    import Spinner from 'svelte-spinner';
    import { createEventDispatcher } from 'svelte';
    import { Tooltip } from 'sveltestrap';

    import { ModalTypeEnum } from '../../../inmate.js';
    
    import AddContactModal from '../../../modal/AddContactModal.svelte';
    import ContactModal from '../../../modal/ContactModal.svelte';

    import ContactNote from "./ContactNote.svelte";

    const dispatch = createEventDispatcher();

    export let id;
    export let inmateUrn;
    export let contactNotes;
    export let unseenDays;
    export let displayDateOnly;
    export let inmateLabel;

    let selectedContact = null;
    let selectedModalType = null;

    function openModal(contact, modalType) {
        selectedModalType = modalType;
        if (modalType === ModalTypeEnum.ADD_CONTACT) {
            selectedContact = { headerText: 'Add Contact', inmateUrn: inmateUrn, inmateName: null, 
                unseenDays : unseenDays };
        } else if (modalType === ModalTypeEnum.CONTACT) {
            selectedContact = { headerText: 'Contact', inmateUrn: inmateUrn, inmateName: null, 
                contactId : contact.contactId, contactDateTime : contact.contactDateTime, previousNotes : contact.contactNotes,
                staff : contact.contactStaffName, dueDate : contact.actionDueDate, previousAction : contact.actionNotes,
                overdueDays : contact.overdueDays, targetedTotalIncreased : contact.targetedTotalIncreased,
                isolationIncreased : contact.isolationIncreased };
        }
    }

    function closeModal(event) {
        selectedContact = null;
        selectedModalType = null;

        if (event.detail.refresh) {
            dispatch('update');
        }
    }
    
    $: contactNote = contactNotes ? contactNotes[0] : null;
</script>

<style>
    .contact-notes-widget {
        display: flex;
        flex-direction: column;
    }

    #add-contact {
        margin: 5px 0 15px 0;
        color: #0267B3;
        font-size: 11px;
        width: 100%;
        text-align: center;
    }

    .no-records {
        padding: 5px 12px;
        max-height: 70px;
        overflow: hidden;
    }

    #contact-count-collapsed {
        display: inline-flex;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        background-color: #efefef;
        color: #0267B3;
        margin-left: 4px;
        cursor: default;
    }

    .unseen-days-warning {
        color: #bb2e3b;
    }
</style>

<div class="contact-notes-widget">
    {#if contactNotes}
        {#if contactNotes.length > 0}
        
            <!-- Show follow up action as an upcoming contact -->
            {#if contactNote.actionDueDate}
                <ContactNote note={contactNote.actionNotes} on:click={() => {openModal(contactNote, ModalTypeEnum.CONTACT)}} 
                    date={contactNote.actionDueDate} {displayDateOnly} upcoming={true} 
                    id={`${id}-${contactNote.contactId}-follow-up`} overdueDays={contactNote.overdueDays}  />
            {/if}

            <ContactNote note={contactNote.contactNotes} date={contactNote.contactDateTime} {displayDateOnly}
                id={`${id}-${contactNote.contactId}`} on:click={() => {openModal(contactNote, ModalTypeEnum.CONTACT)}}
                overdueDays={contactNote.overdueDays} targetedTotalIncreased={contactNote.targetedTotalIncreased}
                isolationIncreased={contactNote.isolationIncreased} />
        {:else}
            {#if !displayDateOnly}
                <span class="no-records">
                    {#if unseenDays > 0}
                        <span class="unseen-days-warning"><i class="bi bi-exclamation-circle-fill" /></span>
                        {inmateLabel} has been targeted for {unseenDays} day{unseenDays == 1 ? '' : 's'} but no contact has been recorded
                    {:else}
                        None recorded
                    {/if}
                </span>

                <button on:click|stopPropagation={() => {openModal(null, ModalTypeEnum.ADD_CONTACT)}} id="add-contact" class="button-reset focus-outline">
                    Add Contact
                </button>
            {:else}
                <span id="contact-count-collapsed">0</span>
                <Tooltip target="contact-count-collapsed" placement="bottom">
                    No contact has been recorded
                </Tooltip>
            {/if}
        {/if}
    {:else}
        <div class="widget-spinner">
            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
        </div>
    {/if}
</div>

{#if selectedContact}
    {#if selectedModalType === ModalTypeEnum.ADD_CONTACT}
        <AddContactModal {...selectedContact} on:close={closeModal} />
    {:else if selectedModalType === ModalTypeEnum.CONTACT}
        <ContactModal {...selectedContact} on:close={closeModal} />               
    {/if}
{/if}